export const DELETE_ROLE_TITLE = "Excluir Perfil";
export const DELETE_ROLE_DESCRIPTION = "Essa ação remove permanentemente o perfil do sistema.";
/** MS001 — alerta de exclusão permanente, apresentado antes da confirmação. */
export const DELETE_ROLE_WARNING =
  "Atenção: essa ação não pode ser desfeita. O perfil será removido permanentemente e não poderá ser recuperado.";
